import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoaderService } from '@core/services/loader.service';
import { SessionService } from '@core/services/session.service';
import { ToastController } from '@ionic/angular';
import * as Sentry from '@sentry/angular';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
@Injectable({ providedIn: 'root' })
export class ErrorHttpInterceptor implements HttpInterceptor {
  constructor(private _router: Router, private _toast: ToastController, private _loader: LoaderService, private _session: SessionService) {
  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(async (error: HttpErrorResponse) => {
        if (error.status == 0) {
          const toast = await this._toast.create({
            animated: true,
            message: `Error de conexion al servidor: ${request.url}`,
            duration: 2500,
            color: 'danger',
          });
          await toast.present();
          this._loader.hide();
          Sentry.captureException(error, {
            extra: {
              url: request.url,
              status: error.status,
              response: error.error,
            },
          });
          this._session.setLoading(false);
          return null;
        }
        if (error.status === 401 || error?.error?.statusCode === 401) {
          console.log(`[401]: ${request.url}`);
          const toast = await this._toast.create({
            animated: true,
            message: `${error.error.message ? error.error.message : error.error.error ? error?.error?.error : 'Error al ejecutar la peticion'}`,
            duration: 2500,
            color: 'danger',
          });
          await toast.present();
          this._loader.hide();
          this._session.setLoading(false);
          Sentry.captureException(error, {
            extra: {
              url: request.url,
              status: error.status,
              response: error.error,
            },
          });
          await this._router.navigate(['login']);
          return null;
        }
        if (error?.status?.toString().charAt(0) === '5' || error?.error?.statusCode?.toString()?.charAt(0) === '5') {
          const toast = await this._toast.create({
            animated: true,
            message: `${error.error.message ? error.error.message : error.error.error ? error?.error?.error : 'Error al ejecutar la peticion'}`,
            duration: 4000,
            color: 'danger',
          });
          await toast.present();
          this._loader.hide();
          this._session.setLoading(false);
          Sentry.captureException(error, {
            extra: {
              url: request.url,
              status: error.status,
              response: error.error,
            },
          });
          throw new Error(error.message);
        }
        throw error;
      }));
  }
}
